import { Reveal } from "@/components/Reveal";
import { AboutContent, Principles } from "@/data/SiteContent";

export default function About() {
  return (
    <section id="nosotros" className="scroll-mt-20 bg-cream py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="mx-auto max-w-3xl text-center">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-dark">
            {AboutContent.Overline}
          </p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            {AboutContent.Title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-ash">{AboutContent.Text}</p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-8 md:grid-cols-3">
          {Principles.map((pPrinciple, pIndex) => (
            <Reveal key={pPrinciple.Id} Delay={pIndex * 120}>
              <div
                data-testid={`principle-card-${pPrinciple.Id}`}
                className="h-full border-t-2 border-gold bg-white px-8 py-10 text-center shadow-sm transition-shadow duration-300 hover:shadow-md"
              >
                <pPrinciple.Icon
                  className="mx-auto h-8 w-8 text-gold-dark"
                  strokeWidth={1.5}
                  aria-hidden="true"
                />
                <h3 className="mt-5 font-serif text-xl text-ink">{pPrinciple.Title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-ash">{pPrinciple.Description}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
